import { hash } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import visibleCheckItem from 'webapp/modifiers/visible-check-item';
import FormCheckboxComponent from 'webapp/components/form/checkbox';
import type { SelectableListItem } from 'webapp/components/selectable-list';

interface Args {
	item: SelectableListItem;
	selectedItems: SelectableListItem[];
	typedFilter: string;
	onSelectionChanged: (item: SelectableListItem, isSelected: boolean) => void;
	onBeforeSelectionChange?: (isChecked: boolean) => Promise<void>;
}

export interface YieldedSettings {
	item: SelectableListItem;
	typedFilter: string;
	isSelected: boolean;
}

interface SelectableListRowComponentInterface {
	Args: Args;
	Blocks: {
		default: [settings: YieldedSettings];
	};
}

export default class SelectableListRowComponent extends Component<SelectableListRowComponentInterface> {
	@tracked isVisibleOnScreen = false;

	get isSelected(): boolean {
		return !!(this.args.selectedItems || []).find(
			(item) => item.value === this.args.item.value,
		);
	}

	get isDisabled(): boolean {
		return !!this.args.item.isDisabled;
	}

	@action
	onBeforeChange(isChecked: boolean): Promise<void> {
		if (this.args.onBeforeSelectionChange) {
			return this.args.onBeforeSelectionChange(isChecked);
		}
		return Promise.resolve();
	}

	@action
	onSelectedChange(isSelected: boolean): void {
		this.args.onSelectionChanged(this.args.item, isSelected);
	}

	@action
	visibleChanged(isVisible: boolean): void {
		this.isVisibleOnScreen = isVisible;
	}
	<template>
		{{#if this.isVisibleOnScreen}}
			<li class="{{if this.isSelected 'selected'}} {{if this.isDisabled 'disabled'}}">

				<FormCheckboxComponent
					@selected={{this.isSelected}}
					@isDisabled={{this.isDisabled}}
					@onBeforeChange={{this.onBeforeChange}}
					@onChange={{this.onSelectedChange}}
				/>

				{{yield (hash item=@item typedFilter=@typedFilter isSelected=this.isSelected)}}

			</li>
		{{else}}
			<li {{visibleCheckItem this.visibleChanged}}></li>
		{{/if}}
	</template>
}
